'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var DEFAULT_SIZE = 24;
exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
    fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
    _ref$width = _ref.width,
    width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
    _ref$style = _ref.style,
    style = _ref$style === undefined ? {} : _ref$style,
    props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);
  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
    style: _extends({
      fill: fill,
      width: width,
      height: height
    }, style)
  }, props), _react2.default.createElement('path', {
    d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
  }));
};